// src/hooks/useFlightReview.jsx
import { useMutation } from "@tanstack/react-query";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

export const useFlightReview = () => {
  return useMutation({
    mutationFn: async (flightBookingRequest) => {
      console.log("API Request - Flight Review Payload:", flightBookingRequest);
      const response = await apiService.post(config.REVIEWHFLIGHT, flightBookingRequest);
      console.log("API Result - Flight Review:", response);
      return response;
    },
  });
};